import packageJson from "../package.json";

// Jira FixVersion 1.0 & Date yyyymmdd e.g: 20210719 = 19-July-2021
const version = "v-" + packageJson.version; // on every release we need to update this

const config = {
  development: {
    apiUrl: process.env.NEXT_PUBLIC_APIURL,
    apiWCFUrl: process.env.NEXT_PUBLIC_WCF_URL,
    webApiUrl: process.env.NEXT_PUBLIC_WEBAPI_URL,
    graphQLUrl: process.env.NEXT_PUBLIC_GRAPHQL_URL,
    reportGraphQLUrl: process.env.NEXT_PUBLIC_REPORT_GRAPHQL_URL,
    signalRUrl: process.env.NEXT_PUBLIC_SIGNALR_URL,
    signalRReportUrl: process.env.NEXT_PUBLIC_SIGNALR_REPORT_URL,
    reportUrl: process.env.NEXT_PUBLIC_REPORT_URL,
    apiVersion: process.env.NEXT_PUBLIC_API_VERSION,
    portalURL: process.env.NEXT_PUBLIC_PORTAL_URL,
    customerPortalURL: process.env.NEXT_PUBLIC_CUSTOMER_PORTAL_URL,
    allowConsoles: true,
    masterCompany: "vendormax",
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
    scriptBotLink:
      process.env.NEXT_PUBLIC_PORTAL_URL +
      "scripts/invitation.ashx?debug=true&company=" +
      process.env.NEXT_PUBLIC_SCRIPTBOT_URL,
    version: process.env.NEXT_PUBLIC_ENVIRONMENT + "-" + version,
    instrumentationConnectionString:
      process.env.NEXT_PUBLIC_INSTRUMENTATION_CONNECTIONSTRING,
    apexchatIframeUrl: process.env.NEXT_PUBLIC_APEXCHAT_IFRAME_URL,
    onRollIframeUrl: process.env.NEXT_PUBLIC_ONROLL_IFRAME_URL,
    hideSectionSettingsForOwnerCompanyKeys:
      process.env.NEXT_PUBLIC_HIDE_SECTION_SETTINGS_FOR_OWNER_COMPANY_KEYS,
    apexchatOwnerCompanyKeys:
      process.env.NEXT_PUBLIC_APEXCHAT_OWNER_COMPANY_KEYS,
    apexchatURLS: process.env.NEXT_PUBLIC_APEXCHAT_URLS,
    GATrackingId: process.env.NEXT_PUBLIC_GA_TRACKING_ID,
    MixpanelToken: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
    authCookieTimeoutInDays:
      process.env.NEXT_PUBLIC_AUTH_COOKIE_TIMEOUT_IN_DAYS,
    idleTimeLimit: process.env.NEXT_PUBLIC_IDLE_TIME_LIMIT,
    blazeoApiUrl: process.env.NEXT_PUBLIC_BLAZEO_API_URL,
    frontdoorApiUrl: process.env.NEXT_PUBLIC_FRONTDOOR_API_BASE_URL,
    frontdoorSignalRUrl: process.env.NEXT_PUBLIC_FRONTDOOR_SIGNALR_URL,
  },
  test: {
    apiUrl: process.env.NEXT_PUBLIC_APIURL,
    apiWCFUrl: process.env.NEXT_PUBLIC_WCF_URL,
    webApiUrl: process.env.NEXT_PUBLIC_WEBAPI_URL,
    graphQLUrl: process.env.NEXT_PUBLIC_GRAPHQL_URL,
    reportGraphQLUrl: process.env.NEXT_PUBLIC_REPORT_GRAPHQL_URL,
    signalRUrl: process.env.NEXT_PUBLIC_SIGNALR_URL,
    signalRReportUrl: process.env.NEXT_PUBLIC_SIGNALR_REPORT_URL,
    reportUrl: process.env.NEXT_PUBLIC_REPORT_URL,
    apiVersion: process.env.NEXT_PUBLIC_API_VERSION,
    portalURL: process.env.NEXT_PUBLIC_PORTAL_URL,
    customerPortalURL: process.env.NEXT_PUBLIC_CUSTOMER_PORTAL_URL,
    allowConsoles: true,
    masterCompany: "vendormax",
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
    scriptBotLink:
      process.env.NEXT_PUBLIC_PORTAL_URL +
      "scripts/invitation.ashx?debug=true&company=" +
      process.env.NEXT_PUBLIC_SCRIPTBOT_URL,
    version: process.env.NEXT_PUBLIC_ENVIRONMENT + "-" + version,
    instrumentationConnectionString:
      process.env.NEXT_PUBLIC_INSTRUMENTATION_CONNECTIONSTRING,
    apexchatIframeUrl: process.env.NEXT_PUBLIC_APEXCHAT_IFRAME_URL,
    onRollIframeUrl: process.env.NEXT_PUBLIC_ONROLL_IFRAME_URL,
    hideSectionSettingsForOwnerCompanyKeys:
      process.env.NEXT_PUBLIC_HIDE_SECTION_SETTINGS_FOR_OWNER_COMPANY_KEYS,
    apexchatOwnerCompanyKeys:
      process.env.NEXT_PUBLIC_APEXCHAT_OWNER_COMPANY_KEYS,
    apexchatURLS: process.env.NEXT_PUBLIC_APEXCHAT_URLS,
    GATrackingId: process.env.NEXT_PUBLIC_GA_TRACKING_ID,
    MixpanelToken: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
    authCookieTimeoutInDays:
      process.env.NEXT_PUBLIC_AUTH_COOKIE_TIMEOUT_IN_DAYS,
    idleTimeLimit: process.env.NEXT_PUBLIC_IDLE_TIME_LIMIT,
    blazeoApiUrl: process.env.NEXT_PUBLIC_BLAZEO_API_URL,
    frontdoorApiUrl: process.env.NEXT_PUBLIC_FRONTDOOR_API_BASE_URL,
    frontdoorSignalRUrl: process.env.NEXT_PUBLIC_FRONTDOOR_SIGNALR_URL,
  },
  staging: {
    apiUrl: process.env.NEXT_PUBLIC_APIURL,
    apiWCFUrl: process.env.NEXT_PUBLIC_WCF_URL,
    webApiUrl: process.env.NEXT_PUBLIC_WEBAPI_URL,
    graphQLUrl: process.env.NEXT_PUBLIC_GRAPHQL_URL,
    reportGraphQLUrl: process.env.NEXT_PUBLIC_REPORT_GRAPHQL_URL,
    signalRUrl: process.env.NEXT_PUBLIC_SIGNALR_URL,
    signalRReportUrl: process.env.NEXT_PUBLIC_SIGNALR_REPORT_URL,
    reportUrl: process.env.NEXT_PUBLIC_REPORT_URL,
    apiVersion: process.env.NEXT_PUBLIC_API_VERSION,
    portalURL: process.env.NEXT_PUBLIC_PORTAL_URL,
    customerPortalURL: process.env.NEXT_PUBLIC_CUSTOMER_PORTAL_URL,
    allowConsoles: true,
    masterCompany: "vendormax",
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
    scriptBotLink:
      process.env.NEXT_PUBLIC_PORTAL_URL +
      "scripts/invitation.ashx?debug=true&company=" +
      process.env.NEXT_PUBLIC_SCRIPTBOT_URL,
    version: process.env.NEXT_PUBLIC_ENVIRONMENT + "-" + version,
    instrumentationConnectionString:
      process.env.NEXT_PUBLIC_INSTRUMENTATION_CONNECTIONSTRING,
    apexchatIframeUrl: process.env.NEXT_PUBLIC_APEXCHAT_IFRAME_URL,
    onRollIframeUrl: process.env.NEXT_PUBLIC_ONROLL_IFRAME_URL,
    hideSectionSettingsForOwnerCompanyKeys:
      process.env.NEXT_PUBLIC_HIDE_SECTION_SETTINGS_FOR_OWNER_COMPANY_KEYS,
    apexchatOwnerCompanyKeys:
      process.env.NEXT_PUBLIC_APEXCHAT_OWNER_COMPANY_KEYS,
    apexchatURLS: process.env.NEXT_PUBLIC_APEXCHAT_URLS,
    GATrackingId: process.env.NEXT_PUBLIC_GA_TRACKING_ID,
    MixpanelToken: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
    authCookieTimeoutInDays:
      process.env.NEXT_PUBLIC_AUTH_COOKIE_TIMEOUT_IN_DAYS,
    idleTimeLimit: process.env.NEXT_PUBLIC_IDLE_TIME_LIMIT,
    blazeoApiUrl: process.env.NEXT_PUBLIC_BLAZEO_API_URL,
    frontdoorApiUrl: process.env.NEXT_PUBLIC_FRONTDOOR_API_BASE_URL,
    frontdoorSignalRUrl: process.env.NEXT_PUBLIC_FRONTDOOR_SIGNALR_URL,
  },
  beta: {
    apiUrl: process.env.NEXT_PUBLIC_APIURL,
    apiWCFUrl: process.env.NEXT_PUBLIC_WCF_URL,
    webApiUrl: process.env.NEXT_PUBLIC_WEBAPI_URL,
    graphQLUrl: process.env.NEXT_PUBLIC_GRAPHQL_URL,
    reportGraphQLUrl: process.env.NEXT_PUBLIC_REPORT_GRAPHQL_URL,
    signalRUrl: process.env.NEXT_PUBLIC_SIGNALR_URL,
    signalRReportUrl: process.env.NEXT_PUBLIC_SIGNALR_REPORT_URL,
    reportUrl: process.env.NEXT_PUBLIC_REPORT_URL,
    apiVersion: process.env.NEXT_PUBLIC_API_VERSION,
    portalURL: process.env.NEXT_PUBLIC_PORTAL_URL,
    customerPortalURL: process.env.NEXT_PUBLIC_CUSTOMER_PORTAL_URL,
    allowConsoles: true,
    masterCompany: "vendormax",
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
    scriptBotLink:
      process.env.NEXT_PUBLIC_PORTAL_URL +
      "scripts/invitation.ashx?debug=true&company=" +
      process.env.NEXT_PUBLIC_SCRIPTBOT_URL,
    version: process.env.NEXT_PUBLIC_ENVIRONMENT + "-" + version,
    instrumentationConnectionString:
      process.env.NEXT_PUBLIC_INSTRUMENTATION_CONNECTIONSTRING,
    apexchatIframeUrl: process.env.NEXT_PUBLIC_APEXCHAT_IFRAME_URL,
    onRollIframeUrl: process.env.NEXT_PUBLIC_ONROLL_IFRAME_URL,
    hideSectionSettingsForOwnerCompanyKeys:
      process.env.NEXT_PUBLIC_HIDE_SECTION_SETTINGS_FOR_OWNER_COMPANY_KEYS,
    apexchatOwnerCompanyKeys:
      process.env.NEXT_PUBLIC_APEXCHAT_OWNER_COMPANY_KEYS,
    apexchatURLS: process.env.NEXT_PUBLIC_APEXCHAT_URLS,
    GATrackingId: process.env.NEXT_PUBLIC_GA_TRACKING_ID,
    MixpanelToken: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
    authCookieTimeoutInDays:
      process.env.NEXT_PUBLIC_AUTH_COOKIE_TIMEOUT_IN_DAYS,
    idleTimeLimit: process.env.NEXT_PUBLIC_IDLE_TIME_LIMIT,
    blazeoApiUrl: process.env.NEXT_PUBLIC_BLAZEO_API_URL,
    frontdoorApiUrl: process.env.NEXT_PUBLIC_FRONTDOOR_API_BASE_URL,
    frontdoorSignalRUrl: process.env.NEXT_PUBLIC_FRONTDOOR_SIGNALR_URL,
  },
  /* Not yet decided */
  production: {
    apiUrl: process.env.NEXT_PUBLIC_APIURL,
    apiWCFUrl: process.env.NEXT_PUBLIC_WCF_URL,
    webApiUrl: process.env.NEXT_PUBLIC_WEBAPI_URL,
    graphQLUrl: process.env.NEXT_PUBLIC_GRAPHQL_URL,
    reportGraphQLUrl: process.env.NEXT_PUBLIC_REPORT_GRAPHQL_URL,
    signalRUrl: process.env.NEXT_PUBLIC_SIGNALR_URL,
    signalRReportUrl: process.env.NEXT_PUBLIC_SIGNALR_REPORT_URL,
    reportUrl: process.env.NEXT_PUBLIC_REPORT_URL,
    apiVersion: process.env.NEXT_PUBLIC_API_VERSION,
    portalURL: process.env.NEXT_PUBLIC_PORTAL_URL,
    customerPortalURL: process.env.NEXT_PUBLIC_CUSTOMER_PORTAL_URL,
    allowConsoles: false,
    masterCompany: "vendormax",
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
    scriptBotLink:
      process.env.NEXT_PUBLIC_PORTAL_URL +
      "scripts/invitation.ashx?debug=true&company=" +
      process.env.NEXT_PUBLIC_SCRIPTBOT_URL,
    version: process.env.NEXT_PUBLIC_ENVIRONMENT + "-" + version,
    instrumentationConnectionString:
      process.env.NEXT_PUBLIC_INSTRUMENTATION_CONNECTIONSTRING,
    apexchatIframeUrl: process.env.NEXT_PUBLIC_APEXCHAT_IFRAME_URL,
    onRollIframeUrl: process.env.NEXT_PUBLIC_ONROLL_IFRAME_URL,
    hideSectionSettingsForOwnerCompanyKeys:
      process.env.NEXT_PUBLIC_HIDE_SECTION_SETTINGS_FOR_OWNER_COMPANY_KEYS,
    apexchatOwnerCompanyKeys:
      process.env.NEXT_PUBLIC_APEXCHAT_OWNER_COMPANY_KEYS,
    apexchatURLS: process.env.NEXT_PUBLIC_APEXCHAT_URLS,
    GATrackingId: process.env.NEXT_PUBLIC_GA_TRACKING_ID,
    MixpanelToken: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
    authCookieTimeoutInDays:
      process.env.NEXT_PUBLIC_AUTH_COOKIE_TIMEOUT_IN_DAYS,
    idleTimeLimit: process.env.NEXT_PUBLIC_IDLE_TIME_LIMIT,
    blazeoApiUrl: process.env.NEXT_PUBLIC_BLAZEO_API_URL,
    frontdoorApiUrl: process.env.NEXT_PUBLIC_FRONTDOOR_API_BASE_URL,
    frontdoorSignalRUrl: process.env.NEXT_PUBLIC_FRONTDOOR_SIGNALR_URL,
  },
};

export default config[process.env.NODE_ENV];
